module.exports = __webpack_public_path__ + "img/logo.acb416af.jpg";